var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-google-maps/~/can-use-dom/index.js
 ** module id = 1264
 ** module chunks = 0
 **/